<template>
  <!-- 创建班级 -->
  <div class="my-set">
    <div class="set-head">
      <div class="header">
        <p class="head-title">完善班级创建信息</p>
        <ul class="head-menu">
          <li class="menu-li">
            <p class="left-title">班级名称</p>
            <p class="desc" v-if="classId && !model.isUserPermission">
              {{ model && model.className }}
            </p>
            <input type="text" maxlength="50" v-model="model.className" placeholder="请输入班级名称" class="input-title"
              @blur="handleClassName" v-else />
          </li>
          <li class="menu-li-tip" v-if="!(classId && !model.isUserPermission)">提示:年月+省市/医院+疾病（基础电生理，房颤等）/研修营+自由命名（例如:2504四川基础电生理培训班)</li>
          <li class="menu-li">
            <p class="left-title">疾病学习目标</p>
            <div class="li-right" @click="handleDisease">
              <p class="desc default-desc" v-if="!model.diseaseNames">请选择</p>
              <p class="desc" v-else>{{ model && model.diseaseNames }}</p>
              <i class="icon-right"></i>
            </div>
          </li>
          <li class="menu-li">
            <p class="left-title">新技术学习目标</p>
            <div class="li-right" @click="handleTechnology">
              <p class="desc default-desc" v-if="!model.technologyNames">请选择</p>
              <p class="desc" v-else>{{ model && model.technologyNames }}</p>
              <i class="icon-right"></i>
            </div>
          </li>
          <li class="menu-li">
            <p class="left-title">班级课表</p>
            <div class="li-right" @click="handleCourse">
              <p class="desc default-desc" v-if="!model.templateName">请选择</p>
              <p class="desc" v-else>{{ model && model.templateName }}</p>
              <i class="icon-right"></i>
            </div>
          </li>
          <li class="menu-li">
            <p class="left-title">课表开始时间</p>
            <div class="li-right" @click="changeCalendar">
              <p class="desc default-desc" v-if="!model.courseStartTime">请选择</p>
              <p class="desc" v-else>{{ model && model.courseStartTime }}</p>
              <i class="icon-right"></i>
            </div>
          </li>
        </ul>
      </div>
      <div class="header code-head" v-if="classId">
        <ul class="head-menu">
          <li class="menu-li">
            <p class="left-title">查看班级二维码</p>
            <div class="li-right" @click="handleCode">
              <p class="desc"></p>
              <i class="icon-right"></i>
            </div>
          </li>
        </ul>
      </div>
      <div class="header code-head" v-if="classId">
        <ul class="head-menu">
          <li class="menu-li">
            <p class="left-title">查看历史班级课表</p>
            <div class="li-right" @click="handleClassHistoryCource">
              <p class="desc"></p>
              <i class="icon-right"></i>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="set-main">
      <div class="member">
        <div class="member-head">
          <p class="head-title menmber-title">选择成员</p>
          <div class="group-box" @click="handleGroup">
            <img src="../../assets/images/grade/icon-group.png" alt="" class="icon-group" />
            <p class="group-desc">分组</p>
            <i class="icon-right icon-right-group"></i>
          </div>
        </div>
        <div @click="handleAddMember(0)" class="member-btn">
          <div class="btn-box">
            <i class="icon-add"></i>
            <p class="btn-title">添加成员</p>
          </div>
        </div>
        <div class="member-box">
          <div v-for="(item, index) in visibleStudentsList" :key="item.id">
            <div class="list_item gruop-menu">
              <div class="group-box">
                <div class="group-item" :class="item.isDropDown ? 'border' : ''">
                  <div class="avatar">
                    <img class="img" src="../../assets/images/grade/mask-group-q.png" alt=""
                      v-if="item.groupName === 'CLASS_UNGROUPED_MARK_IT'" />
                    <img class="img" src="../../assets/images/grade/mask-group.png" alt="" v-else />
                  </div>
                  <div class="info" @click="changeSwitchGroup(item, index)">
                    <div class="user user-no">
                      <div class="user_data">
                        <span class="name">{{ item.groupName === 'CLASS_UNGROUPED_MARK_IT' ? '未分组' : item.groupName }}
                        </span>
                      </div>
                      <div class="drop-down">
                        <img src="../../assets/images/grade/drop-down.png" alt="" class="icon-drop"
                          v-if="item && item.isDropDown" />
                        <img src="../../assets/images/grade/drop-up.png" alt="" class="icon-drop" v-else />
                      </div>
                    </div>
                  </div>
                </div>
                <template v-if="item && item.isDropDown">
                  <div class="member-menu" v-for="(aitem, aindex) in item.students" :key="aindex">
                    <img :src="aitem.headPicUrl || defaultStudentUserUrl" alt="avatar" class="avatar" />
                    <div class="menu-level">
                      <span class="title">{{ aitem.realName || aitem.userInfo && aitem.userInfo.realName }}
                        <template v-if="aitem.hospitalName || aitem.userInfo && aitem.userInfo.hospitalName">
                          - {{ aitem.hospitalName || aitem.userInfo && aitem.userInfo.hospitalName }}
                        </template>
                      </span>
                      <div class="level-box">
                        <img src="../../assets/images/grade/icon-current.png" alt="" class="icon-current">
                        <p class="level-title">{{ aitem.currentStageCj || aitem.userInfo && aitem.userInfo.currentStageCj
                        }}</p>
                      </div>
                    </div>
                    <p @click="removeStudents(aitem.id, index)" class="menu-btn" v-if="model.isUserPermission">
                      移出
                    </p>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <!-- <div class="down-box" @click="switchStudent" v-if="model.studentsList && model.studentsList.length > 4">
            <img src="../../assets/images/grade/drop-down.png" alt="" class="icon-down" v-if="!isStudentsAll"/>
            <img src="../../assets/images/grade/drop-up.png" alt="" class="icon-down" v-else/>
            <p class="down-title">
              {{ isStudentsAll? "收起" : "展开" }}
            </p>
          </div> -->
        </div>
      </div>
      <div class="member">
        <p class="head-title mb14">选择管理员</p>
        <div class="member-btn" @click="handleAddMember(1)">
          <div class="btn-box">
            <i class="icon-add"></i>
            <p class="btn-title">添加管理员</p>
          </div>
        </div>
        <div class="member-box">
          <div class="member-menu" v-for="item in visibleAdminList" :key="item.originalId">
            <img :src="item.headPicUrl || defaultAdminUserUrl" alt="avatar" class="avatar" />
            <div class="menu-box">
              <div class="box-top">
                <span class="title">{{ item.realName }} <template v-if="item.hospitalName">-</template> {{
                  item.hospitalName }}</span>
                <img src="../../assets/images/grade/icon-admin.png" class="icon-admin" v-if="item.roleType == 1" />
              </div>
            </div>
            <p @click="removeAdmin(item.id)" class="menu-btn" v-if="item.roleType !== 1 && model.isAdminPermission">
              移出
            </p>
          </div>
          <div class="down-box" @click="switchAdmins" v-if="model.adminsList && model.adminsList.length > 4">
            <img src="../../assets/images/grade/drop-down.png" alt="" class="icon-down" v-if="!isAdminAll" />
            <img src="../../assets/images/grade/drop-up.png" alt="" class="icon-down" v-else />
            <p class="down-title">
              {{ isAdminAll ? "收起" : "展开" }}
            </p>
          </div>
        </div>
      </div>
      <ul class="member-set" v-if="classId && model.isAdminPermission">
        <li class="set-li" v-for="(item, index) in setList" :key="index">
          <p class="title">{{ item.label }}</p>
          <div class="icon-right" @click="handleOperate(item)">
            <img src="../../assets/images/grade/icon-right.png" alt="" />
          </div>
        </li>
      </ul>
    </div>
    <div class="confirm" @click="handleSave">
      {{ classId ? "确认" : "创建班级" }}
    </div>
    <div class="delModel" v-if="isDelModel">
      <div class="model-dissolve">
        <p class="head">提示</p>
        <p class="title">
          感谢您的陪伴，为了让美好的回忆永远留存，您可以将班级转让给其他管理员，让他们继续。
        </p>
        <div class="dissolve-box">
          <div class="btnclose" @click="handleRransfer">转让班级</div>
          <div class="btn0k" @click="handleDissolve">狠心解散</div>
        </div>
      </div>
    </div>
    <div class="delModel" v-if="isRemoveStudent">
      <div class="model-dissolve">
        <p class="head">提示</p>
        <p class="title">
          确认移出?
        </p>
        <div class="dissolve-box">
          <div class="btnclose" @click="handleCloseRemove">取消</div>
          <div class="btn0k" @click="handleRemoveStudent">确定</div>
        </div>
      </div>
    </div>
    <modelCalendar ref="modelCalendar" @handleCalendar="handleCalendar"></modelCalendar>
  </div>
</template>

<script>
import {
  addClassroom,
  classroomDetails,
  editClassroom,
  dismissClassroom,
  classUserPermissions
} from '@/api/grade'
import modelCalendar from './components/model-calendar.vue'
import withRouteTracking from '@/utils/withRouteTracking'
import { debounce } from '@/utils/util'
const UserProfile = {
  name: 'createGrade',
  components: {
    modelCalendar
  },
  data () {
    return {
      className: '',
      isRemoveStudent: false,
      removeId: '',
      isRemoveAdminId: '',
      isStudentsAll: false,
      setList: [
        { label: '转让班级(管理员)', value: 1 },
        { label: '解除班级', value: 2 }
      ],
      isDelModel: false,
      defaultStudentUserUrl: require('@/assets/images/grade/icon-student.png'),
      defaultAdminUserUrl: require('@/assets/images/grade/icon-doctor.png'),
      model: {
        className: '',
        studentsList: [],
        adminsList: [],
        diseaseNames: '',
        technologyNames: '',
        isUserPermission: false, // 用户权限
        isAdminPermission: false, // 超管权限
        templateId: '',
        templateName: '',
        courseStartTime: ''
      },
      membersList: [],
      adminsList: [],
      studentIds: [],
      classId: '',
      confirmLoading: false,
      isAdminAll: false,
      removeGroupIndex: -1, // 判断是否删除了分组里面的内容
    }
  },
  computed: {
    userId () {
      return this.$store.getters.userInfo.id
    },
    visibleStudentsList () {
      if (this.model.studentsList.length) {
        return this.model.groupUsers
      } else {
        return []
      }
    },
    visibleAdminList () {
      if (this.model.adminsList) {
        return this.isAdminAll ? this.model.adminsList : this.model.adminsList.slice(0, 4)
      } else {
        return []
      }
    },
    createGradeJSON () {
      return JSON.parse(`${sessionStorage.getItem('createGrade')}`)
    },
  },
  created () {
    sessionStorage.setItem('changeGradeTabActive', 1)
    let classId = this.$route.query.classId
    if (classId) {
      this.classId = classId
      sessionStorage.setItem('classId', this.classId)
    } else {
      this.model.isUserPermission = true
      this.model.isAdminPermission = true
      this.$forceUpdate()
    }
    if (!this.createGradeJSON) return
    const {
      className = '',
      adminsList = [],
      studentsList = [],
      isAdminPermission,
      isUserPermission,
      technologyNames = [],
      diseaseNames = [],
      groupUsers = [],
      templateId = '',
      templateName = '',
      courseStartTime = '',
    } = this.createGradeJSON
    // 处理diseaseNames和technologyNames
    this.model.diseaseNames = Array.isArray(diseaseNames) ? diseaseNames.join(',') : diseaseNames
    this.model.technologyNames = Array.isArray(technologyNames) ? technologyNames.join(',') : technologyNames
    // 设置其他模型属性
    this.model.templateId = templateId
    this.model.className = className
    this.model.templateName = templateName
    this.model.courseStartTime = courseStartTime
    this.model.isUserPermission = isUserPermission
    this.model.isAdminPermission = isAdminPermission
    // 处理studentsList和groupUsers
    if (studentsList.length > 0) {
      this.model.studentsALLList = studentsList
      this.model.studentsList = studentsList
      if (groupUsers.length > 0) {
        // 使用Set存储学生ID以加速查找过程
        let studentIds = new Set()
        let ungroupedIndex = -1
        // 遍历groupUsers，填充studentIds并找到未分组（'CLASS_UNGROUPED_MARK_IT'）的索引
        groupUsers.forEach((item, index) => {
          if (item.students && item.students.length > 0) {
            item.students.forEach(student => studentIds.add(student.id))
          }
          if (item.groupName === 'CLASS_UNGROUPED_MARK_IT') {
            ungroupedIndex = index
          }
        })
        // 将不在任何组中的学生添加到未分组中
        studentsList.forEach(student => {
          if (!studentIds.has(student.id)) {
            if (ungroupedIndex !== -1) { // 有系统未分组
              groupUsers[ungroupedIndex] && groupUsers[ungroupedIndex].students && groupUsers[ungroupedIndex].students.push(student)
            } else { // 还未分组，但添加成员
              const ungroupedGroup = groupUsers.find(item => item.groupName === 'CLASS_UNGROUPED_MARK_IT') || { students: [] }
              ungroupedGroup.students.push(student)
            }
          }
        })
        // 更新model.groupUsers，同时确保每个group都有isDropDown属性设置为true
        this.model.groupUsers = groupUsers.map(item => ({
          ...item,
          isDropDown: (item.students && item.students.length > 0)
        }))
      } else {
        this.model.groupUsers = [{
          groupName: 'CLASS_UNGROUPED_MARK_IT',
          classId: '',
          createTime: Date.now(),
          isDropDown: true,
          students: studentsList
        }]
      }
    } else {
      this.model.studentsALLList = []
      this.model.studentsList = []
    }
    // 处理adminsList
    this.model.adminALLList = adminsList.length > 0 ? adminsList : []
    this.model.adminsList = adminsList.length > 0 ? adminsList : []
    // 更新sessionStorage
    this.updateSessionStorage('createGrade', { ...this.model })
    // 强制视图更新
    this.$forceUpdate()
  },
  async mounted () {
    if (this.classId && !sessionStorage.getItem('createGrade')) {
      await this.getClassUserPermissions()
      await this.handleClassroomDetails()
    }
  },
  methods: {
    changeCalendar () {
      this.$refs.modelCalendar.init()
    },
    // 课表开始时间回调
    handleCalendar (val) {
      this.model.courseStartTime = val
      this.$forceUpdate()
    },
    // 选择课表
    handleCourse () {
      sessionStorage.setItem('createGrade', JSON.stringify(this.model))
      this.$router.push({
        path: '/courseSchedule',
        query: {
          classId: this.classId,
          templateId: this.model.templateId
        }
      })
    },
    changeSwitchGroup (item, index) {
      this.visibleStudentsList[index].isDropDown = !this.visibleStudentsList[index].isDropDown
      this.$forceUpdate()
    },
    // 分组
    handleGroup () {
      if (!this.visibleStudentsList.length) return this.$toast('请先添加成员！')
      this.$router.push({
        path: '/gradeGroup',
        query: {
          classId: this.classId
        }
      })
    },
    handleDisease (item) {
      if (this.classId) {
        this.$router.push({
          path: '/gradeSelectiveDisease',
          query: {
            classId: this.classId
          }
        })
      } else {
        this.$router.push({
          path: '/gradeSelectiveDisease',
        })
      }
    },
    // 新技术
    handleTechnology () {
      if (!this.classId && !this.model.diseaseNames.length) {
        return this.$toast('请先选择疾病学习目标!')
      }
      this.$router.push({
        path: '/gradeSelectiveTechnique',
        query: {
          classId: this.classId,
        },
      })
    },
    // 获取用户班级角色权限
    async getClassUserPermissions () {
      const params = {
        classId: this.classId,
        userId: this.userId
      }
      await classUserPermissions(params).then(res => {
        // roleType: 1 班级超管 2 班级管理员 3班级学员
        this.model.isUserPermission = [1, 2].includes(res.data.roleType)
        this.model.isAdminPermission = [1].includes(res.data.roleType)
        this.$forceUpdate()
      })
    },
    // 班级详情
    handleClassroomDetails () {
      const params = {
        classId: this.classId
      }
      classroomDetails(params).then(res => {
        const data = res.data
        let hasDefaultGroup = false
        this.model.className = data.className
        this.model.id = data.id
        const admins = this.filterList(data.admins)
        let newStudents = []
        data.groupUsers.map(item => {
          hasDefaultGroup = (item.groupName === 'CLASS_UNGROUPED_MARK_IT')
          if (item.students && item.students.length > 0) {
            newStudents = newStudents.concat(item.students)
          }
        })
        if (!hasDefaultGroup) {
          data.groupUsers.push({
            groupName: 'CLASS_UNGROUPED_MARK_IT',
            classId: '',
            createTime: Date.now(),
            isDropDown: true,
            students: []
          })
        }
        this.model.groupUsers = data.groupUsers.map(item => {
          item.isDropDown = item.students && item.students.length > 0
          return item
        })
        this.model.groupUsersList = data.groupUsers.map(item => {
          if (item.students && item.students.length > 0) {
            item.students = item.students.map(stu => {
              if (stu.groupRoleType === 1) {
                item.leaderRealName = stu.userInfo.realName
              }
              return Object.assign(stu, stu.userInfo)
            })
          }
          return item
        }).filter(item => item.groupName !== 'CLASS_UNGROUPED_MARK_IT')
        console.log(newStudents, '23')
        this.model.studentsALLList = newStudents
        this.model.studentsList = this.model.studentsALLList
        this.model.adminALLList = JSON.parse(JSON.stringify(admins))
        this.model.adminsList = this.model.adminALLList
        this.model.diseaseNames = data.diseaseList.map(acc => acc.diseaseName).join(',')
        this.model.technologyNames = data.technologyList.map(acc => acc.technologyName).join(',')
        this.model.templateName = data.template ? data.template.templateName : ''
        this.model.templateId = data.templateId ? data.templateId : ''
        this.model.courseStartTime = data.courseStartTime ? this.$moment(data.courseStartTime * 1).format('YYYY-MM-DD') : ''
        sessionStorage.setItem('createGrade', JSON.stringify(this.model))
        this.$forceUpdate()
      })
    },
    // 组装数据
    filterList (item) {
      let list = []
      item.filter(acc => {
        let obj = {}
        obj.roleType = acc.roleType
        obj.id = acc.userId
        obj.originalId = acc.id
        obj.currentLevel = acc.userInfo && acc.userInfo.currentLevel
        obj.realName = acc.userInfo && acc.userInfo.realName
        obj.headPicUrl = acc.userInfo && acc.userInfo.headPicUrl
        obj.hospitalName = acc.userInfo && acc.userInfo.hospitalName
        obj.currentStageCj = acc.userInfo && acc.userInfo.currentStageCj
        list.push(obj)
      })
      return list
    },
    handleOperate (item) {
      if (item.value === 1) {
        this.handleRransfer()
      } else {
        this.isDelModel = true
      }
    },
    // 转让
    handleRransfer () {
      this.$router.push({
        path: '/selectAdmin',
        query: {
          classId: this.classId
        }
      })
      this.isDelModel = false
    },
    // 解散
    handleDissolve () {
      const params = {
        classId: this.classId,
        classStatus: 0
      }
      dismissClassroom(params).then(res => {
        sessionStorage.removeItem('createGrade')
        sessionStorage.removeItem('classId')
        this.isDelModel = false
        this.$toast('操作成功!')
        this.$router.push({
          path: '/grade'
        })
      })
    },
    handleClassName () {
      if (!sessionStorage.getItem('createGrade') && !this.classId) {
        sessionStorage.setItem(
          'createGrade',
          JSON.stringify({ ...this.model })
        )
      } else {
        this.updateSessionStorage('createGrade', { ...this.model })
      }
    },
    // 添加成员/管理员
    handleAddMember (memberType) {
      this.handleClassName()
      this.$router.push({
        path: '/selectMember',
        query: {
          memberType
        }
      })
    },
    // 提交
    async handleSave() {
      if (!this.model.className) {
        return this.$toast('班级名称不能为空')
      }
      if (!this.model.diseaseNames) {
        return this.$toast('疾病学习目标不能为空')
      }
      if (!this.model.technologyNames) {
        return this.$toast('新技术学习目标不能为空')
      }
      if (!this.model.studentsList.length) {
        return this.$toast('请选择成员')
      }
      if (!this.model.templateId) {
        return this.$toast('请选择课表')
      }
      if (!this.model.courseStartTime) {
        return this.$toast('请选择课表开始时间')
      }

      // if (!this.model.adminsList.length) {
      //   return this.$toast('请选择管理员')
      // }
      // let arr = []
      let arr = this.visibleStudentsList.map(group => ({
        id: group.id,
        createTime: group.createTime,
        groupName: group.groupName,
        students: group.students && group.students.length > 0 ? group.students.map(student => ({ userId: student.id, groupRoleType: student.groupRoleType || 3 })) : []
      }))
      const params = {
        className: this.model.className,
        studentGroups: arr,
        studentIds: this.model.studentsList.map(acc => acc.id),
        adminIds: this.model.adminsList.map(acc => acc.id),
        diseaseNames: this.model.diseaseNames.split(','),
        technologyNames: this.model.technologyNames.split(','),
        templateId: this.model.templateId,
        courseStartTime: new Date(this.model.courseStartTime).getTime(),
        reimport: this.createGradeJSON && this.createGradeJSON.reimport ? this.createGradeJSON.reimport : false,
      }
      this.classId && (params.classId = this.classId)
      if (this.confirmLoading) return
      this.confirmLoading = true
      try {
        const res = this.classId ? await editClassroom(params) : await addClassroom(params)
        if (res.data.code === 'MembersExist') { // 成员存在
          this.confirmLoading = false
          return this.$toast(`${res.data.data.join(',')}已加入其他班级，请重新选择`)
        } else if (res.data.code === 'LoginUserErr') { // 登录人信息获取失败
          this.confirmLoading = false
          return this.$toast(res.data.msg)
        } else if (res.data.code === 'LockUserPhoneClass') {
          this.confirmLoading = false
          return this.$toast(res.data.msg)
        } else {
          sessionStorage.removeItem('createGrade')
          sessionStorage.removeItem('classId')
          if (this.classId) {
            this.$router.push({
              path: '/gradeHomePage',
              query: {
                classId: this.classId
              }
            })
          } else {
            this.$router.push({
              path: '/createGradeSucc',
              query: {
                classId: res.data.data,
                className: this.model.className,
              }
            })
          }
        }
      } catch (e) {
        throw e
      } finally {

      }
    },
    // 查看二维码
    handleCode () {
      this.$router.push({
        path: '/gradeCode',
        query: {
          classId: this.classId,
          type: 'gradeDetails', // 页面类型
        }
      })
    },
    // 查看历史班级课表
    handleClassHistoryCource () {
      this.$router.push({
        path: '/classHistoryCource',
        query: {
          classId: this.classId,
        }
      })
    },

    // 移出成员
    handleRemoveStudentByGroup () {
      if (this.removeId) {
        const {
          groupUsersList = [],
          groupUsers = []
        } = this.createGradeJSON
        groupUsers.forEach(item => {
          if (item.students && item.students.length > 0) {
            item.students = item.students.filter(delItem => delItem.id !== this.removeId)
          }
        })
        groupUsersList.forEach(item => {
          if (item.students && item.students.length > 0) {
            item.students = item.students.filter(delItem => {
              if (delItem.groupRoleType === 1) {
                item.leaderRealName = ''
              }
              return delItem.id !== this.removeId
            })
          }
        })
        this.updateSessionStorage('createGrade', {
          groupUsersList,
          groupUsers
        })
      }
    },

    handleRemoveStudent: debounce(function () {
      this.isRemoveStudent = false
      if (this.removeId) {
        this.model.studentsList = this.model.studentsList.filter(m => m.id !== this.removeId)
        this.model.studentsALLList = this.model.studentsALLList.filter(m => m.id !== this.removeId)
        if (this.removeGroupIndex > -1) {
          this.model.groupUsers[this.removeGroupIndex].students = this.model.groupUsers[this.removeGroupIndex].students.filter(m => m.id !== this.removeId)
        }
        this.handleRemoveStudentByGroup()
        this.removeId = ''
        this.updateSessionStorage('createGrade', {
          studentsList: this.model.studentsList,
          studentsALLList: this.model.studentsALLList
        })
      } else {
        this.model.adminsList = this.model.adminsList.filter(a => a.id !== this.isRemoveAdminId)
        this.model.adminALLList = this.model.adminALLList.filter(a => a.id !== this.isRemoveAdminId)
        this.updateSessionStorage('createGrade', {
          adminsList: this.model.adminsList,
          adminALLList: this.model.adminALLList
        })
        this.isRemoveAdminId = ''
      }
      this.$toast('移出成功')
      this.$forceUpdate()
    }, 500),
    handleCloseRemove () {
      this.removeId = ''
      this.isRemoveAdminId = ''
      this.isRemoveStudent = false
    },
    removeStudents (id, index) {
      this.removeId = id
      this.removeGroupIndex = index
      this.isRemoveStudent = true
      this.isRemoveAdminId = ''
    },
    updateSessionStorage (sessionStorageName, value) {
      let prevData = JSON.parse(sessionStorage.getItem(sessionStorageName))
      Object.keys(value).forEach(function (val, key) {
        prevData[val] = value[val]
      })
      sessionStorage.setItem(sessionStorageName, JSON.stringify(prevData))
    },
    switchStudent () {
      this.isStudentsAll = !this.isStudentsAll
    },
    switchAdmins () {
      this.isAdminAll = !this.isAdminAll
    },
    removeAdmin (id) {
      this.isRemoveStudent = true
      this.removeId = ''
      this.isRemoveAdminId = id
    }
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.my-set {
  position: relative;
  background: #F9F8F7;
  padding: 12px 10px 16px;
  box-sizing: border-box;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;

  .set-head {
    .header {
      // height: 172px;
      margin-bottom: 8px;
      background: #ffffff;
      border-radius: 12px;
      padding: 10px 12px 0;
      box-sizing: border-box;
      border: 1px solid #ffffff;

      .head-title {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 600;
        font-size: 14px;
        color: #282828;
        line-height: 20px;
        margin-bottom: 22px;
        position: relative;

      }

      .head-menu {
        margin: 0;
        padding: 0;
        overflow-y: auto;
        height: calc(100vh - 460px);

        .menu-li {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;

          .left-title {
            font-family: PingFang HK, PingFang HK;
            font-weight: 400;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.6);
            line-height: 20px;
          }

          .input-title {
            border: none !important;
            text-align: right !important;
            flex: 1;
            margin-left: 50px;

            &::-webkit-input-placeholder {
              /* placeholder颜色 */
              color: #AEAEAE !important;
              /* placeholder字体大小 */
              font-size: 14px !important;
            }
          }

          .li-right {
            display: flex;
            align-items: baseline;
            flex: 1;
            overflow: hidden;

            .desc {
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 400;
              font-size: 14px;
              color: #000000;
              line-height: 20px;
              flex: 1;
              text-align: right;
            }

            .default-desc {
              color: #AEAEAE;
            }

            .icon-right {
              background: url("../../assets/images/grade/icon-right.png") no-repeat center center / 100% 100%;
              width: 6px;
              height: 12px;
              display: inline-block;
              margin-left: 4px;
            }
          }

          .desc {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
            flex: 1;
            text-align: right;
            overflow: hidden;
            margin-left: 20px;
          }
        }

        .menu-li-tip {
          height: 40px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #EB1700;
          line-height: 20px;
          margin-bottom: 10px;
          margin-top: -10px;
        }
      }
    }

    .code-head {
      padding: 16px 12px;

      .head-menu {
        height: auto;
      }

      .head-menu>.menu-li {
        margin-bottom: 0;
      }
    }
  }

  .set-main {
    height: calc(100vh - 172px - 42px);
    overflow-y: auto;

    .member {
      background: #fff;
      border-radius: 12px;
      margin-bottom: 8px;
      padding: 12px 10px 6px;

      .member-head {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 14px;
        height: 24px;

        .head-title {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 600;
          font-size: 14px;
          color: #282828;
          position: relative;

        }

        .menmber-title {
          position: relative;

          &::after {
            content: "";
            position: absolute;
            top: 5px;
            left: 48%;
          }
        }

        .group-box {
          // width: 69px;
          height: 24px;
          border-radius: 22px;
          background: #EB1700;
          display: flex;
          justify-content: space-between;
          padding: 0 8px;
          align-items: center;

          img {
            width: 13px;
            height: 14px;
          }

          .group-desc {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            margin-left: 4px;
          }

          .icon-right {
            background: url("../../assets/images/grade/icon-right.png") no-repeat center center / 100% 100%;
            width: 6px;
            height: 12px;
            display: inline-block;
            margin-left: 4px;

            &.icon-right-group {
              width: 12px;
              background: url("../../assets/images/grade/right2.png") no-repeat center center / 100%;
            }
          }
        }
      }

      .head-title {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 600;
        font-size: 14px;
        color: #282828;
        position: relative;

      }

      .mb14 {
        margin-bottom: 14px;
      }

      .member-btn {
        height: 40px;
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        flex-direction: column;
        background: #ffffff;
        border-radius: 4px;
        padding: 10px 0 10px;
        box-sizing: border-box;
        border: 1px solid rgba(0, 0, 0, 0.2);

        .btn-box {
          display: flex;
          align-items: center;

          .icon-add {
            background: url("../../assets/images/grade/icon-add.png") no-repeat center center / 100% 100%;
            width: 12px;
            height: 12px;
            margin-right: 2px;
          }

          .btn-title {
            font-family: PingFang HK, PingFang HK;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
          }
        }
      }

      .member-box {
        position: relative;

        .list_item {
          width: 343px;
          // min-height: 74px;
          margin-bottom: 8px;
          background-color: #F9F8F7;
          border-radius: 12px;
          box-sizing: border-box;
          display: flex;
          align-items: center;

          .group-box {
            width: 100%;

            // box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.06);
            .group-item {
              display: flex;
              align-items: center;
              height: 62px;
              padding: 0 10px;
              box-sizing: border-box;
            }

            .border {
              border-bottom: 1px solid #E6EBEE;
              margin-bottom: 8px;
            }

            .group-menu {
              padding: 10px 7px;

              .list_item {
                background: #F0F5F8 !important;
                width: 100%;

                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
          }

          .avatar {
            width: 32px;
            height: 32px;
            margin-right: 10px;
            border-radius: 50%;
            overflow: hidden;

            .img {
              width: 32px;
              height: 32px;
            }
          }

          .info {
            width: 275px;

            .user {
              display: flex;
              justify-content: space-between;
              margin-bottom: 8px;
              align-items: center;

              .user_data {
                display: flex;
                align-items: center;
                overflow: hidden;
                flex: 1;

                .name {
                  margin-right: 4px;
                  font-family: Source Han Sans CN, Source Han Sans CN;
                  font-weight: 400;
                  font-size: 14px;
                  color: #000000;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .user_type {
                  transform: translateY(2px);
                  display: flex;

                  .img1 {
                    width: 56px;
                    height: 13px;
                    margin-left: 2px;
                  }

                  .img2 {
                    width: 38px;
                    height: 13px;
                    margin-left: 2px;
                  }

                  .img3 {
                    width: 29px;
                    height: 13px;
                    margin-left: 2px;
                  }

                  .icon-status {
                    width: 39px;
                    height: 13px;
                    margin-left: 4px;
                  }

                  .level-group {
                    height: 13px;
                    box-sizing: border-box;
                    position: relative;
                    border: 1px solid #EB1700;
                    border-radius: 2px;
                    padding: 0 6px;
                    font-family: Source Han Sans CN, Source Han Sans CN;
                    font-weight: 500;
                    font-size: 10px;
                    line-height: 12px;
                    color: #EB1700;
                    margin-left: 4px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
              }

              .study_report {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 82px;
                height: 24px;
                background: rgba(235, 23, 0, 0.1);
                border-radius: 22px 22px 22px 22px;

                .report-title {
                  font-weight: 400;
                  font-size: 14px;
                  color: #EB1700;
                }

                .study-right {
                  background: url('../../assets/images/grade/study-right.png') no-repeat center center / 100% 100%;
                  width: 6px;
                  height: 10px;
                  margin-left: 4px;
                }
              }

              .drop-down {
                .icon-drop {
                  width: 13px;
                  height: 8px;
                }
              }

              .time {
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 400;
                font-size: 12px;
                color: #7a8494;
              }
            }

            .user-no {
              margin-bottom: 0;
            }

            .hospital {
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 500;
              font-size: 14px;
              color: #7a8494;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        .member-menu {
          display: flex;
          align-items: center;
          padding: 0 10px;
          width: 100%;
          box-sizing: border-box;
          margin-bottom: 16px;

          .avatar {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            margin-right: 8px;
          }

          .menu-level {
            width: calc(100% - 70px);
            display: flex;
            flex-direction: column;

            .title {
              // flex: 1;
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 400;
              font-size: 14px;
              color: #000000;
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin: 0;
              // width: calc(100% - 56px);
            }

            .level-box {
              margin-top: 2px;
              display: flex;
              align-items: center;

              .icon-current {
                height: 15px;
                margin-right: 2px;
              }

              .level-title {
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 500;
                font-size: 14px;
                color: #7A8494;
                line-height: 20px;
              }
            }
          }

          .title {
            flex: 1;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            position: relative;
            margin: 0;

            .icon-admin {
              width: 56px;
              height: 13px;
            }
          }

          .menu-box {
            width: calc(100% - 80px);
            padding-right: 10px;
            position: relative;

            .box-top {
              position: relative;
              display: flex;
              align-items: center;

              .title {
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 400;
                font-size: 14px;
                color: #000000;
                line-height: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin: 0;
                width: calc(100% - 56px);
              }

              .icon-admin {
                width: 56px;
                height: 13px;
                margin-left: 2px;
              }
            }
          }

          .menu-btn {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.5);
            line-height: 20px;
          }
        }

        .down-box {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          bottom: 10px;

          .icon-down {
            width: 13px;
            height: 8px;
            margin-right: 4px;
          }

          .down-title {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #000;
            line-height: 20px;
          }
        }
      }
    }
  }

  .member-set {
    background: #fff;
    border-radius: 12px;
    margin-bottom: 16px;
    padding: 16px 10px;

    .set-li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      margin-bottom: 24px;

      &:last-child {
        margin-bottom: 0;
      }

      .title {
        flex: 1;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 20px;
      }

      .icon-right {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        img {
          width: 8px;
          height: 13px;
        }
      }
    }
  }

  .delModel {
    position: fixed;
    z-index: 3;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 26px;

    .model-dissolve {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -160px;
      margin-top: -98px;
      background: #fff;
      width: 320px;
      height: 195px;
      border-radius: 15px;
      padding: 15px 17px 16px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .head {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 600;
        font-size: 17px;
        color: #000000;
        line-height: 20px;
        margin-bottom: 20px;
        text-align: center;
      }

      .title {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.8);
        margin: 0 16px;
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }

      .h60 {
        height: 60px;
      }

      .dissolve-box {
        margin-top: 16px;
        display: flex;
        align-items: center;

        .btnclose {
          flex: 1;
          height: 42px;
          background: #F1EFED;
          border-radius: 20px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #81766F;
          line-height: 42px;
          text-align: center;
        }

        .btn0k {
          margin-left: 27px;
          flex: 1;
          height: 42px;
          background: #EB1700;
          box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
          border-radius: 22px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
          line-height: 42px;
          text-align: center;
        }
      }
    }
  }
}

.confirm {
  width: 100%;
  height: 42px;
  background: #EB1700;
  box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
  border-radius: 22px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 42px;
}
</style>



// WEBPACK FOOTER //
// src/views/grade/createGrade.vue